var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.83125 0 0 7.83125 0 17.5C0 27.1688 7.83125 35 17.5 35C27.1688 35 35 27.1688 35 17.5C35 7.83125 27.1688 0 17.5 0ZM26.25 23.7738L23.7738 26.25L17.5 19.9762L11.2262 26.25L8.75 23.7738L15.0238 17.5L8.75 11.2262L11.2262 8.75L17.5 15.0238L23.7738 8.75L26.25 11.2262L19.9762 17.5L26.25 23.7738Z",
    fill: "#F04F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toastError.51bedd10ecb1cd22b464d6d41ba19155.svg";
export { ForwardRef as ReactComponent };